import React from 'react';

export default function CardReview() {
  return (
    <div className="border rounded px-5 py-9 w-auto">
      <div className="flex sm:flex-row flex-col items-center mb-6">
        <img
          src="/assets/images/user.png"
          alt="user"
          className="md:w-[78px] md:h-[78px] w-[39px] h-[39px] rounded-full"
        />
        <div className="md:ml-9 sm:ml-4 ml-0">
          <p className="text-[#666666] md:text-2xl text-sm font-medium text-center">
            Ahmad Budiyarto
          </p>
          <div className="flex items-center mt-2">
            <img src="/assets/images/star.svg" alt="star" className="w-max" />
            <img src="/assets/images/star.svg" alt="star" className="w-max" />
          </div>
        </div>
      </div>
      <p className="text-[#999999] md:text-sm text-xs">
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </p>
    </div>
  );
}
// import React from 'react';

// export default function CardReview() {
//   return (
//     // <div className="grid grid-cols-3">
//     <div className="border rounded px-5 py-9">
//       <div className="flex items-center mb-6">
//         <img src="/assets/images/user.png" alt="user" />
//         <div className="ml-9">
//           <p className="text-[#666666] text-2xl font-medium">Ahmad Budiyarto</p>
//           <div className="flex items-center mt-2">
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//             <img src="/assets/images/star.svg" alt="star" className="w-max" />
//           </div>
//         </div>
//       </div>
//       <p className="text-[#999999] text-sm">
//         Lorem ipsum dolor sit amet, consectetur adipiscing elit. Magna aliquet quis tempor egestas
//         egestas mi lectus erat a. Volutpat morbi lorem risus. Lorem ipsum dolor sit amet,
//         consectetur adipiscing elit. Magna aliquet quis tempor egestas egestas mi lectus erat a.
//         Volutpat morbi lorem risus.
//       </p>
//     </div>
//     // </div>
//   );
// }
